import React from 'react';
import { Colors } from '../../../../../shared/theme';
export default {
  marginBottom: {
    marginBottom: 0
  } as React.CSSProperties,
  inlineBlock: {
    display: 'inline-block'
  } as React.CSSProperties,
  defaultContent: {
    backgroundColor: Colors.white,
    // padding: 20,
  } as React.CSSProperties,
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: 16,
    height: 56
  } as React.CSSProperties,
  headerText: {
    fontSize: 24
  } as React.CSSProperties,
  icon: {
    width: 16,
    height: 16
  } as React.CSSProperties,
  tableWrapper: {
    backgroundColor: Colors.white,
    padding: 20
  } as React.CSSProperties,
};

export const martCategoryLayout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 16 },
};

export const buttonLayout = {
  wrapperCol: { offset: 10, span: 16 },
};
